import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextLanguagesPipe } from './text-languages/text-languages.pipe';
import { ImageToUrlPipe } from './imageToUrl/image-to-url.pipe';
import { CurrenciePipe } from './currencie/currencie.pipe';
@NgModule({
  declarations: [TextLanguagesPipe, ImageToUrlPipe, CurrenciePipe],
  imports: [CommonModule],
  exports: [TextLanguagesPipe, ImageToUrlPipe, CurrenciePipe],
})
export class PipesModule {}
